import UiPageListSearch from "./UiPageListSearch";
import UiPageListSearch_DynamicSearchItem from "./UiPageListSearch_DynamicSearchItem";
import { EnumUiDynamicSearchItemType } from "./EnumUiDynamicSearchItemType";
import { EnumCompare } from "./EnumCompare";
import { EnumOrderServiceType, EnumOrderServiceTypeOption } from "./EnumOrderServiceType";

/**
 * 委托书-干线物流分页列表-搜索条件分页列表-搜索条件
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListSearchOrderPoolTrunk extends UiPageListSearch {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 委托书Id
     */
    PoolId?: string;
    /**
     * 订单Id
     */
    OrderId?: string;
    /**
     * 服务类型
     */
    ServiceType?: EnumOrderServiceType;
}

/**
 * 委托书-干线物流分页列表-搜索条件分页列表-搜索条件-表单校验
 */
export const DtoPageListSearchOrderPoolTrunkRules = {
}

/**
 * 委托书-干线物流分页列表-搜索条件分页列表-搜索条件-动态搜索配置项
 */
export const DtoPageListSearchOrderPoolTrunkDynamicSearchItems: UiPageListSearch_DynamicSearchItem[]  = [
]
